import { themesAdapter, ThemeState } from './theme.entity';
import { createReducer, on, Action } from '@ngrx/store';
import { themesActionTypes } from './theme.actions';
import { EntityState } from '@ngrx/entity';
import { Theme } from './../../../api/models/theme.model';
import { authActionTypes } from './../../../auth/store/auth.actions';


export const initialState: ThemeState = themesAdapter.getInitialState({
    ids: [],
    loaded: false,
    total: null,
    newlyCreatedTheme: null
});

export const themesReducerObj = createReducer(
    initialState,

    on(themesActionTypes.setThemesAction, (state, action) => {

        if (action.themes && action.themes !== null && action.themes.length > 0) {
            return themesAdapter.addAll(action.themes, {
                ...state,
                loaded: true,
                total: action.themes && action.themes !== null ? action.themes.length : 0,
            });
        }
        else {
            return {
                ...state,
                loaded: true,
                total: 0
            };
        }

    }
    ),

    on(themesActionTypes.setDefaultThemeForScene, (state, action) => {
        return {
            ...state,
            locationId: action.locationId
        };
    }),

    on(themesActionTypes.clear, (state, action) => {
        return themesAdapter.removeAll(state);
    }),

    on(authActionTypes.LogOut, (state, action) => {
        // return accountAdapter.removeAll({ ...state, currentAccount:null })
        return themesAdapter.removeAll({
            ...state,
            loaded: false,
            total: 0
        });
    }),

    on(themesActionTypes.addThemeSuccess, (state, action) => {

        if (state.entities[action.theme.Id])
            return state;
        else
            return themesAdapter.addOne(action.theme, {
                ...state,
                total: state.total + 1,
                newlyCreatedTheme: action.theme
            });
    }
    ),

    on(themesActionTypes.resetNewlyCreatedTheme, (state, action) => {
        return {
            ...state,
            newlyCreatedTheme: null
        }
    }),

    on(themesActionTypes.deleteThemeSuccess, (state, action) => {
        return themesAdapter.removeOne(action.themeId, {
            ...state,
            total: state.total - 1
        });
    }
    ),

    on(themesActionTypes.updateThemeSuccess, (state, action) => {
        return themesAdapter.updateOne(action.update, state);
    }
    )
);

export function reducer(state: ThemeState = initialState, action: Action): ThemeState {
    return themesReducerObj(state, action);
}

export const themesSelectors = themesAdapter.getSelectors();
